import PropTypes from 'prop-types';
import React from 'react';
import { CheckBoxElement } from './CheckBox.react';

class ToggleInput extends React.Component {
  constructor(props) {
    super(props);
    this._handleChange = this._handleChange.bind(this);
    this._onFocus = this._onFocus.bind(this);
    this._onBlur = this._onBlur.bind(this);

    this.state = {
      focus: false,
    };
  }

  _handleChange(e) {
    const isDisabled = this.props.disabled;
    const isChecked = this.props.selected;

    if (!isDisabled && isChecked && this.props.onUncheck) {
      this.props.onUncheck(this.props.value);
    } else if (!isDisabled && !isChecked && this.props.onCheck) {
      this.props.onCheck(this.props.value);
    }
  }

  _onFocus() {
    this.setState({ focus: true });
  }

  _onBlur() {
    this.setState({ focus: false });
  }

  render() {
    const { props: { buttonWidth, buttonHeight, element, selected, align, disabled }, state: { focus } } = this;

    return (<div className={ 'toggle-input toggle-input-' + this.props.align }>
      <input id={this.props.id} name={this.props.name} type={this.props.inputType}
        onChange={this._handleChange} onFocus={this._onFocus} onBlur={this._onBlur} disabled={disabled} />
      <div style={ { minWidth: buttonWidth, width: buttonWidth, height: buttonHeight } }>
        {React.cloneElement(element, { width: buttonWidth, height: buttonHeight, selected, focused: focus })}
      </div>
      <label htmlFor={this.props.id}>{this.props.label}</label>
    </div>);
  }

}

ToggleInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  selected: PropTypes.bool,
  element: PropTypes.element.isRequired,
  onCheck: PropTypes.func,
  onUncheck: PropTypes.func,
  value: PropTypes.any,
  buttonWidth: PropTypes.number,
  buttonHeight: PropTypes.number,
  align: PropTypes.oneOf(['top', 'center']),
  disabled: PropTypes.bool,
  inputType: PropTypes.string,
};

ToggleInput.defaultProps = {
  selected: false,
  inputType: 'checkbox',
  buttonWidth: 40,
  buttonHeight: 40,
  align: 'center',
  disabled: false,
};

export default ToggleInput;
